import {
  STOCK_TAKING_CAR_MANAGEMENT_GET_REPORT_FILE_BEGIN,
  STOCK_TAKING_CAR_MANAGEMENT_GET_REPORT_FILE_SUCCESS,
  STOCK_TAKING_CAR_MANAGEMENT_GET_REPORT_FILE_FAILURE
} from './constants'
import { BFFAgent } from 'BFFAgent'
import { XML_TYPE } from 'Utilities'
import * as FileSaver from 'file-saver'
import moment from 'moment'

export function getReport(fromDate, toDate, isAsofixSAS) {
  return async dispatch => {
    dispatch({
      type: STOCK_TAKING_CAR_MANAGEMENT_GET_REPORT_FILE_BEGIN
    })

    try {
      BFFAgent.Stock.TakingCarManagement.generateExcelManangement(fromDate, toDate, isAsofixSAS)
        .then(reportExel => {
          const today = moment().format('DD-MM-YYYY');
          const file = new Blob([reportExel], {
            // Mime type de excel
            type: XML_TYPE
          })
          // Descargo el archivo
          FileSaver.saveAs(file, `Gestión de usados - ${today}.xlsx`)

          dispatch({
            type: STOCK_TAKING_CAR_MANAGEMENT_GET_REPORT_FILE_SUCCESS
          })
        })
        .catch(err => {
          dispatch({
            type: STOCK_TAKING_CAR_MANAGEMENT_GET_REPORT_FILE_FAILURE,
            data: { error: err }
          })
        })
    } catch (err) {
      dispatch({
        type: STOCK_TAKING_CAR_MANAGEMENT_GET_REPORT_FILE_FAILURE,
        data: { error: err }
      })
    }
  }
}

export function reducer(state, action) {
  switch (action.type) {
    case STOCK_TAKING_CAR_MANAGEMENT_GET_REPORT_FILE_BEGIN:
      return {
        ...state,
        takingCarManagement: {
          ...state.takingCarManagement,
          reportPending: true,
          reportError: null,
          reportSuccess: false,
        }
      }
    case STOCK_TAKING_CAR_MANAGEMENT_GET_REPORT_FILE_SUCCESS:
      return {
        ...state,
        takingCarManagement: {
          ...state.takingCarManagement,
          reportPending: false,
          reportError: null,
          reportSuccess: true,
        }
      }
    case STOCK_TAKING_CAR_MANAGEMENT_GET_REPORT_FILE_FAILURE:
      return {
        ...state,
        takingCarManagement: {
          ...state.takingCarManagement,
          reportPending: false,
          reportError: action.data.error,
          reportSuccess: false,
        }
      }
    default:
      return state
  }
}
